// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__GafUF","inner":"Footer_inner__HNgvu"};